<template>
  <!-- THIS ALL SHOULD BE PART OF OUR VUE MODULES PACKAGE -->
  <div
    v-if="showLegalMessage"
    class="orbviz-legal"
  >
    <a
      href="https://orbviz.com/home/privacy-policy/"
      class="text-reset"
      target="_blank"
    >
      Privacy Policy
    </a>
    <a
      href="https://orbviz.com/home/website-tou/"
      class="text-reset"
      target="_blank"
    >
      Terms and Conditions
    </a>
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class OrbVizLegal extends Vue {
  get showLegalMessage () {
    return window.location.hostname !== 'rates.ecan.govt.nz'
  }
}

</script>

<style scoped>

.orbviz-legal {
  font-size: 0.5em;
}

</style>
